// Job requirements generation *********************************************************************
// pathname: /v1/job-requirements/generate
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobGenerateRequirementsProps {
  locale: Locale,
  payload: {
    title: string;
    description?: string;
  };
  shouldFetch?: boolean,
  successCallback?: () => void,
}

interface JobGeneratedRequirementsResponse {
  questions: string[];
}

/**
 * @description SWR: fetch job requirement questions.
 * - `locale` - the current locale
 * - `payload` - the payload
 * - `shouldFetch` - condition for fetching the data. Default true.
 * - `successCallback` - success callback; works only on successful fetch
 */
export const useSwrJobGenerateRequirements = (props: UseSwrJobGenerateRequirementsProps) => {
  const {
    locale,
    payload,
    shouldFetch = true,
    successCallback,
  } = props;

  return useSwrApi<JobGeneratedRequirementsResponse>({
    url: '/v1/job-requirements/generate',
    locale,
    shouldFetch,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      payload,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      keepPreviousData: true,
      dedupingInterval: 1000 * 60, // 1 minute
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
  });
};
